import "./signature.css";
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {setPersonalData} from "../../../redux/personal_store";
import {setOwnerData} from "../../../redux/owner_info_store";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import apiClient from "../../../utils/axios";

import {connect} from "react-redux";

function Signature({personalData, appData, ownerData, setPersonalData}) {
    let backTo = '/review'

    if (appData.sub_account_type === 'omnibus') backTo = '/personal'

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [signature, setSignature] = useState({
        fullName: "",
        ownerFullName: "",
        clientIP: ""
    });

    const [signatureErrors, setSignatureErrors] = useState({
        fullName: "",
        ownerFullName: "",
    });

    useEffect(() => {
        setSignature((prevSignature) => ({
            ...prevSignature,
            fullName: "",
        }));
    }, [personalData.firstName, personalData.middleName, personalData.lastName]);

    useEffect(() => {
        setSignature((prevSignature) => ({
            ...prevSignature,
            ownerFullName: "",
        }));
    }, [ownerData.joint_first_name, ownerData.joint_middle_name, ownerData.joint_last_name]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSignatureErrors({
            fullName: "",
            ownerFullName: "",
        });

        let isValid = true;

        const lowerCaseSignature = signature.fullName ? signature.fullName.trim() : "";
        const lowerOwnerCaseSignature = signature.ownerFullName ? signature.ownerFullName.trim() : "";

        if (!lowerCaseSignature) {
            setSignatureErrors((prevErrors) => ({
                ...prevErrors,
                fullName: t("errors.required_field"),
            }));
            isValid = false;
        }

        if (appData.account_type === "joint") {
            if (!lowerOwnerCaseSignature) {
                setSignatureErrors((prevErrors) => ({
                    ...prevErrors,
                    ownerFullName: t("errors.required_field"),
                }));
                isValid = false;
            }
        }

        if (!personalData || !ownerData) {
            return null;
        }

        if (isValid) {
            setPersonalData(personalData);
            if (!appData.app_id) alert("Missing app id");

            try {
                await updateSignatureValues();
                navigate("/welcome-to");
            } catch (error) {
                setSignatureErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const getClientIP = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            return null;
        }
    };

    const getSignatureValues = () => {
        return {
            SignatureName: signature.fullName,
            OwnerName: signature.ownerFullName,
        };
    };

    const updateSignatureValues = async () => {
        const clientIP = await getClientIP();

        if (!clientIP) {
            return;
        }

        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step7/` + appData.app_id;
        const params = getSignatureValues();
        params.signature_ip = clientIP;

        try {
            const response = await apiClient.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
            });

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="signature w-full">
            <Logout/>
            <p className="sign_and_submit_heading text-center font-normal md:text-7xl text-5xl">{t("signature.sign_and_submit")}</p>
            <p className="heading_content text-white xl:text-center text-justify font-semibold m-auto sm:text-xl text-base">
                {t("signature.terms_and_conditions")}
                <a
                    style={{color: "unset"}}
                    className="underline"
                    href="https://www.choicetrade.com/legal.php?page=RiskDisclosure"
                    target="_blank"
                    rel="noreferrer"
                >
                    {t("signature.risk_disclosure_statement")}
                </a>
                {t("signature.service_fee")}
            </p>

            <p className="heading_content text-white xl:text-center text-justify font-semibold m-auto sm:text-xl text-base">{t("signature.arbitration_agreement")}</p>

            <form onSubmit={handleSubmit} className="mt-5">
                <div className="flex justify-content-around flex-wrap row-gap-5">
                    <div>
                        <p className="heading_content text-white xl:text-center text-justify font-semibold m-auto sm:text-xl text-base">
                            {t("signature.primary_account")} {t("signature.signature")}
                        </p>
                        <div className="signature_message sm:w-27rem w-full p-4 text-center">
                            <p className="signature_message_text text-xl font-bold">{t("signature.signature_line")}</p>
                        </div>
                        <div className="text-center">
                            <input
                                type="text"
                                placeholder={`${personalData.firstName} ${personalData.middleName} ${personalData.lastName}`}
                                className="signature_input sm:w-27rem w-full text-white"
                                name="fullName"
                                value={signature.fullName}
                                onChange={(e) => {
                                    setSignature((prevSignature) => ({...prevSignature, fullName: e.target.value}));
                                }}
                            />
                            {signatureErrors.fullName &&
                                <p className="text-start text-white font-base mt-2 mb-3 ml-2">{signatureErrors.fullName}</p>}
                        </div>
                    </div>

                    {appData.account_type === "joint" &&
                        <div>
                            <p className="heading_content text-white xl:text-center text-justify font-semibold m-auto sm:text-xl text-base">Joint
                                Owner signature:</p>
                            <div className="signature_message w-27rem p-4 text-center">
                                <p className="signature_message_text text-xl font-bold">{t("signature.signature_line")}</p>
                            </div>
                            <div className="text-center">
                                <input
                                    type="text"
                                    placeholder={`${ownerData.joint_first_name} ${ownerData.joint_middle_name} ${ownerData.joint_last_name}`}
                                    className="signature_input sm:w-27rem w-full text-white"
                                    name="ownerFullName"
                                    value={signature.ownerFullName}
                                    onChange={(e) => {
                                        setSignature((prevSignature) => ({
                                            ...prevSignature,
                                            ownerFullName: e.target.value
                                        }));
                                    }}
                                />
                                {signatureErrors.ownerFullName &&
                                    <p className="text-start text-white font-base mt-2 mb-3 ml-2">{signatureErrors.ownerFullName}</p>}
                            </div>
                        </div>
                    }
                </div>

                <div
                    className="flex justify-content-center align-items-center gap-4 sm:flex-row flex-column-reverse row-gap-3 pt-4">
                    <Link className="no-underline" to={backTo}>
                        <button className="back_btn">{t("back_btn")}</button>
                    </Link>
                    <button className="continue_btn" type="submit">
                        {t("next_btn")}
                    </button>
                </div>

                {signatureErrors.submitError && (
                    <div className="text-red-500 text-center">
                        {signatureErrors.submitError}
                    </div>
                )}
            </form>
        </div>
    );
}

const mapStateToProps = (state) => ({
    personalData: state.personalData,
    appData: state.appData,
    ownerData: state.ownerData
});

const mapDispatchToProps = {
    setPersonalData,
    setOwnerData
};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);